// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LabItem-module__font-s-10___RXohR {
  font-size: 10px !important;
}

.LabItem-module__font-s-12___qVMTF {
  font-size: 12px !important;
}

.LabItem-module__font-s-13___abXf2 {
  font-size: 13px !important;
}

.LabItem-module__font-s-14___zkuiZ {
  font-size: 14px !important;
}

.LabItem-module__font-s-15___SagDn {
  font-size: 15px !important;
}

.LabItem-module__font-s-16___Q0KK2 {
  font-size: 16px !important;
}

.LabItem-module__font-s-18___Ik9aX {
  font-size: 18px !important;
}

.LabItem-module__font-s-20___zqHSO {
  font-size: 20px !important;
}

.LabItem-module__font-s-22___Mbs9A {
  font-size: 22px !important;
}

.LabItem-module__font-s-28___kkZA3 {
  font-size: 28px !important;
}

.LabItem-module__font-w-400___kgQB7 {
  font-weight: 400 !important;
}

.LabItem-module__font-w-500___vnbDy {
  font-weight: 500 !important;
}

.LabItem-module__font-w-600___XPfqW {
  font-weight: 600 !important;
}

.LabItem-module__font-w-700___iFqDn {
  font-weight: 700 !important;
}

.LabItem-module__p-5___XHmDw {
  padding: 5px !important;
}

.LabItem-module__p-12___TS8uC {
  padding: 12px !important;
}

.LabItem-module__p-16___RWMla {
  padding: 16px !important;
}

.LabItem-module__p-30___vUWgQ {
  padding: 30px !important;
}

.LabItem-module__p-b-0___tGpwd {
  padding-bottom: 0 !important;
}

.LabItem-module__p-b-5___hqNGj {
  padding-bottom: 5px !important;
}

.LabItem-module__p-b-10___C5mU2 {
  padding-bottom: 10px !important;
}

.LabItem-module__p-b-12___dMuVX {
  padding-bottom: 12px !important;
}

.LabItem-module__p-b-16___OJNk7 {
  padding-bottom: 16px !important;
}

.LabItem-module__p-b-18___fLo38 {
  padding-bottom: 18px !important;
}

.LabItem-module__p-b-20___ZBv3_ {
  padding-bottom: 20px !important;
}

.LabItem-module__p-b-25___p1Hxn {
  padding-bottom: 25px !important;
}

.LabItem-module__p-b-30___KHJpJ {
  padding-bottom: 30px !important;
}

.LabItem-module__p-b-50___M6cyn {
  padding-bottom: 50px !important;
}

.LabItem-module__p-t-0___aPR53 {
  padding-top: 0 !important;
}

.LabItem-module__p-t-12___Xunr6 {
  padding-top: 12px !important;
}

.LabItem-module__p-t-16___VGS_W {
  padding-top: 16px !important;
}

.LabItem-module__p-t-18___aDTp1 {
  padding-top: 18px !important;
}

.LabItem-module__p-t-20___b71fR {
  padding-top: 20px !important;
}

.LabItem-module__p-t-30___ugUEI {
  padding-top: 30px !important;
}

.LabItem-module__p-t-40___RoNyb {
  padding-top: 40px !important;
}

.LabItem-module__p-t-50___zJUXL {
  padding-top: 50px !important;
}

.LabItem-module__p-l-20___A25VM {
  padding-left: 20px !important;
}

.LabItem-module__p-l-30___m0g1n {
  padding-left: 30px !important;
}

.LabItem-module__p-l-40___QVlSP {
  padding-left: 40px !important;
}

.LabItem-module__p-r-16___vLMJ9 {
  padding-right: 16px !important;
}

.LabItem-module__p-r-20___UQlaX {
  padding-right: 20px !important;
}

.LabItem-module__p-r-30___Z9pBY {
  padding-right: 30px !important;
}

.LabItem-module__p-r-50___kcqEI {
  padding-right: 50px !important;
}

.LabItem-module__p-r-60___m3914 {
  padding-right: 60px !important;
}

.LabItem-module__m-b-1___Tu1sr {
  margin-bottom: 1px !important;
}

.LabItem-module__m-b-2___Iuj7q {
  margin-bottom: 2px !important;
}

.LabItem-module__m-b-6___PDLL7 {
  margin-bottom: 6px !important;
}

.LabItem-module__m-b-8___z8xfV {
  margin-bottom: 8px !important;
}

.LabItem-module__m-b-10___G68uC {
  margin-bottom: 10px !important;
}

.LabItem-module__m-b-14___YWALU {
  margin-bottom: 14px !important;
}

.LabItem-module__m-b-16___NUcYq {
  margin-bottom: 16px !important;
}

.LabItem-module__m-b-20___S5t_S {
  margin-bottom: 20px !important;
}

.LabItem-module__m-b-22___Hhuta {
  margin-bottom: 22px !important;
}

.LabItem-module__m-b-24___ixY2O {
  margin-bottom: 24px !important;
}

.LabItem-module__m-b-30___J8vaj {
  margin-bottom: 30px !important;
}

.LabItem-module__m-b-32___dowoW {
  margin-bottom: 32px !important;
}

.LabItem-module__m-b-40___xnh3v {
  margin-bottom: 40px !important;
}

.LabItem-module__m-t-2___dNm4g {
  margin-top: 2px !important;
}

.LabItem-module__m-t-3____bHye {
  margin-top: 3px !important;
}

.LabItem-module__m-t-4___MaK2U {
  margin-top: 4px !important;
}

.LabItem-module__m-t-5___X02eE {
  margin-top: 5px !important;
}

.LabItem-module__m-t-8___HmUTW {
  margin-top: 8px !important;
}

.LabItem-module__m-t-10___GApzO {
  margin-top: 10px !important;
}

.LabItem-module__m-t-15____JYcz {
  margin-top: 15px !important;
}

.LabItem-module__m-t-16____wU1A {
  margin-top: 16px !important;
}

.LabItem-module__m-t-20___G_mKs {
  margin-top: 20px !important;
}

.LabItem-module__m-t-22___obb0N {
  margin-top: 22px !important;
}

.LabItem-module__m-t-30___nOydx {
  margin-top: 30px !important;
}

.LabItem-module__m-t-32___fFnam {
  margin-top: 32px !important;
}

.LabItem-module__m-l-auto___EJAoN {
  margin-left: auto !important;
}

.LabItem-module__m-l-4___xa6TP {
  margin-left: 4px !important;
}

.LabItem-module__m-l-5___yHYmD {
  margin-left: 5px !important;
}

.LabItem-module__m-l-6___kkbGd {
  margin-left: 6px !important;
}

.LabItem-module__m-l-8___XC5wL {
  margin-left: 8px !important;
}

.LabItem-module__m-l-10___BxUp9 {
  margin-left: 10px !important;
}

.LabItem-module__m-l-16___dl_Xj {
  margin-left: 16px !important;
}

.LabItem-module__m-l-20___I7wnu {
  margin-left: 20px !important;
}

.LabItem-module__m-l-24___mJenI {
  margin-left: 24px !important;
}

.LabItem-module__m-l-30___EQ60q {
  margin-left: 30px !important;
}

.LabItem-module__m-l-35___n75eg {
  margin-left: 35px !important;
}

.LabItem-module__m-l-40___fQOEX {
  margin-left: 40px !important;
}

.LabItem-module__m-r-8___pqkim {
  margin-right: 8px !important;
}

.LabItem-module__m-r-10___jWvDg {
  margin-right: 10px !important;
}

.LabItem-module__m-r-16___UUBm_ {
  margin-right: 16px !important;
}

.LabItem-module__m-r-20___uI5WO {
  margin-right: 20px !important;
}

.LabItem-module__m-r-24___wp2nr {
  margin-right: 24px !important;
}

.LabItem-module__m-r-30___lE0pd {
  margin-right: 30px !important;
}

.LabItem-module__m-r-40___Qsw1o {
  margin-right: 40px !important;
}

.LabItem-module__border-r-3___d5cV7 {
  border-radius: 3px !important;
}

.LabItem-module__border-r-4___CmlmP {
  border-radius: 4px !important;
}

.LabItem-module__border-r-6___cWwCB {
  border-radius: 6px !important;
}

.LabItem-module__border-r-10___JoKD7 {
  border-radius: 10px !important;
}

.LabItem-module__border-r-12___fedfG {
  border-radius: 12px !important;
}

.LabItem-module__border-r-16___L41y0 {
  border-radius: 16px !important;
}

.LabItem-module__border-r-50___rb43L {
  border-radius: 50% !important;
}

.LabItem-module__primary-border___BmQl4 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.LabItem-module__primary-border-b___P12jV {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.LabItem-module__primary-border-t___aBolF {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.LabItem-module__primary-border-l___scXR2 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.LabItem-module__primary-border-r___WEO2Y {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.LabItem-module__secondary-border___R0L8O {
  border: 1px solid #637768;
}

.LabItem-module__secondary-border-b___Cd1_L {
  border-bottom: 1px solid #637768;
}

.LabItem-module__secondary-border-t____t3Hf {
  border-top: 1px solid #637768;
}

.LabItem-module__secondary-border-l___h2vqp {
  border-left: 1px solid #637768;
}

.LabItem-module__secondary-border-r___QutMq {
  border-right: 1px solid #637768;
}

.LabItem-module__gap-0___XoW2N {
  gap: 0 !important;
}

.LabItem-module__gap-2___VO22Z {
  gap: 2px !important;
}

.LabItem-module__gap-4___u6ig2 {
  gap: 4px !important;
}

.LabItem-module__gap-5___T5xrC {
  gap: 5px !important;
}

.LabItem-module__gap-6___UNdqK {
  gap: 6px !important;
}

.LabItem-module__gap-8___rzmqm {
  gap: 8px !important;
}

.LabItem-module__gap-10___q0zvC {
  gap: 10px !important;
}

.LabItem-module__gap-12___YmSNF {
  gap: 12px !important;
}

.LabItem-module__gap-14___IHG5I {
  gap: 14px !important;
}

.LabItem-module__gap-16___IOTXt {
  gap: 16px !important;
}

.LabItem-module__gap-18___BOYWD {
  gap: 18px !important;
}

.LabItem-module__gap-20___AkfW1 {
  gap: 20px !important;
}

.LabItem-module__gap-24___YCHN5 {
  gap: 24px !important;
}

.LabItem-module__gap-26___ZiN2x {
  gap: 26px !important;
}

.LabItem-module__gap-30___Tskb9 {
  gap: 30px !important;
}

.LabItem-module__gap-32___EpOLO {
  gap: 32px !important;
}

.LabItem-module__gap-40___s4dRc {
  gap: 40px !important;
}

.LabItem-module__gap-50___NHR5n {
  gap: 50px !important;
}

.LabItem-module__flex-1___SMWu2 {
  flex: 1;
}

.LabItem-module__flex-none___BQ2iv {
  flex: none !important;
}

.LabItem-module__flex-column___GnuQx {
  display: flex;
  flex-direction: column !important;
}

.LabItem-module__flex-row___BD6LW {
  display: flex;
  flex-direction: row !important;
}

.LabItem-module__vertically-centered___GqZ7a {
  display: flex;
  align-items: center !important;
}

.LabItem-module__horizontally-centered___oIsmx {
  display: flex;
  justify-content: center !important;
}

.LabItem-module__horizontally-end___HzwMS {
  display: flex;
  justify-content: end !important;
}

.LabItem-module__vertically-start___nVIjE {
  display: flex;
  align-items: start !important;
}

.LabItem-module__space-between___M_CoM {
  display: flex;
  justify-content: space-between !important;
}

.LabItem-module__flex-wrap___s8JEE {
  flex-wrap: wrap !important;
}

.LabItem-module__height-100___eXHme {
  height: 100%;
}

.LabItem-module__width-50___ZFSiH {
  width: 50% !important;
}

.LabItem-module__width-100___JiQEg {
  width: 100%;
}

.LabItem-module__cursor-pointer___Yaa7g {
  cursor: pointer;
}

.LabItem-module__cursor-not-allowed___H_qym {
  cursor: not-allowed !important;
}

.LabItem-module__absolute-centered___pA1uL {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.LabItem-module__absolute___EAtXF {
  position: absolute;
}

.LabItem-module__relative___Ey486 {
  position: relative;
}

.LabItem-module__fixed___dYMme {
  position: fixed;
}

.LabItem-module__visible___fABPI {
  opacity: 1;
}

.LabItem-module__invisible___yB_ul {
  opacity: 0;
}

.LabItem-module__col-90___K7GAq {
  width: 90% !important;
}

.LabItem-module__col-auto___uxkAG {
  width: auto !important;
}

.LabItem-module__medical-tabs___xjBtI {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.LabItem-module__medical-table-new___RxMdm {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LabItem-module__medical-table-new___RxMdm:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LabItem-module__medical-table-new___RxMdm::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LabItem-module__medical-table-new___RxMdm::-webkit-scrollbar-track {
  display: none;
}
.LabItem-module__medical-table-new___RxMdm.LabItem-module__no-pagination___RIBBw {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LabItem-module__medical-table-new___RxMdm.LabItem-module__no-pagination___RIBBw:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LabItem-module__medical-table-new___RxMdm.LabItem-module__no-pagination___RIBBw::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LabItem-module__medical-table-new___RxMdm.LabItem-module__no-pagination___RIBBw::-webkit-scrollbar-track {
  display: none;
}

.LabItem-module__medical-table-empty___XubMC {
  padding: 14px 40px !important;
}

.LabItem-module__icon-btn___Mh73m {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.LabItem-module__search-icon___OxJjF {
  width: 24px;
  height: 24px;
  align-self: center;
}

.LabItem-module__disable-select___HCdGV {
  user-select: none;
}

.LabItem-module__break-word___Z3vZs {
  word-break: break-word;
}

.LabItem-module__popup-clear-btn___eTMuC {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.LabItem-module__scroll-m-b-20___x7TEm {
  scroll-margin-bottom: 20px;
}

.LabItem-module__item____ejlH {
  background-color: #fdfcfa;
  margin: 0 30px 0 100px;
  border-radius: 12px;
  padding: 12px 25px;
  justify-content: space-between;
}
.LabItem-module__item____ejlH.LabItem-module__borderRadius___tvWW_ {
  border-radius: 12px 12px 0 0;
}
.LabItem-module__item____ejlH .LabItem-module__content___jAg8L {
  display: flex;
  align-items: flex-start;
}
.LabItem-module__item____ejlH .LabItem-module__content___jAg8L .LabItem-module__icon___KHmNu {
  width: 34px;
  height: 34px;
}
.LabItem-module__item____ejlH .LabItem-module__content___jAg8L .LabItem-module__type___LmbB2 {
  color: #a79988;
}
.LabItem-module__item____ejlH .LabItem-module__content___jAg8L .LabItem-module__value___eyr1k {
  color: #375844;
}
.LabItem-module__item____ejlH .LabItem-module__content___jAg8L .LabItem-module__description___MibVV {
  color: #637768;
}
.LabItem-module__item____ejlH .LabItem-module__button___D6reY {
  flex-direction: row;
  border-radius: 33px !important;
  border-width: 1px;
  padding: 6px 8px;
  width: auto;
}
.LabItem-module__item____ejlH .LabItem-module__button___D6reY > span {
  font-size: 14px !important;
}
.LabItem-module__item____ejlH .LabItem-module__button___D6reY > img {
  width: 16px;
  height: 16px;
}
.LabItem-module__item____ejlH .LabItem-module__toggleButton___GC6Uh {
  cursor: pointer;
  margin-left: auto;
  transition: transform 0.3s ease-in-out;
  padding: 10px;
}
.LabItem-module__item____ejlH .LabItem-module__toggleButton___GC6Uh.LabItem-module__collapsed___Afefa {
  transform: rotate(-90deg);
}

.LabItem-module__accordion___v60Vq {
  border-radius: 0 0 12px 12px;
  margin: 0 30px 0 100px;
  padding: 12px 70px;
  border-top: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Labs/items/LabItem/LabItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AA8pBF;AA5pBE;EACE,4BAAA;AA8pBJ;AA3pBE;EACE,aAAA;EACA,uBAAA;AA6pBJ;AA3pBI;EACE,WAAA;EACA,YAAA;AA6pBN;AA1pBI;EACE,cAAA;AA4pBN;AAzpBI;EACE,cAAA;AA2pBN;AAxpBI;EACE,cAAA;AA0pBN;AAtpBE;EACE,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAwpBJ;AAtpBI;EACE,0BAAA;AAwpBN;AArpBI;EACE,WAAA;EACA,YAAA;AAupBN;AAnpBE;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,aAAA;AAqpBJ;AAnpBI;EACE,yBAAA;AAqpBN;;AAhpBA;EACE,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAmpBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.item {\n  background-color: get-color(grayNew, ultra-light);\n  margin: 0 30px 0 100px;\n  border-radius: 12px;\n  padding: 12px 25px;\n  justify-content: space-between;\n\n  &.borderRadius {\n    border-radius: 12px 12px 0 0;\n  }\n\n  .content {\n    display: flex;\n    align-items: flex-start;\n\n    .icon {\n      width: 34px;\n      height: 34px;\n    }\n\n    .type {\n      color: get-color(orangeNew, medium-dark);\n    }\n\n    .value {\n      color: get-color(greenNew, dark);\n    }\n\n    .description {\n      color: get-color(greenNew, medium-dark);\n    }\n  }\n\n  .button {\n    flex-direction: row;\n    border-radius: 33px !important;\n    border-width: 1px;\n    padding: 6px 8px;\n    width: auto;\n\n    & > span {\n      font-size: 14px !important;\n    }\n\n    & > img {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .toggleButton {\n    cursor: pointer;\n    margin-left: auto;\n    transition: transform 0.3s ease-in-out;\n    padding: 10px;\n\n    &.collapsed {\n      transform: rotate(-90deg);\n    }\n  }\n}\n\n.accordion {\n  border-radius: 0 0 12px 12px;\n  margin: 0 30px 0 100px;\n  padding: 12px 70px;\n  border-top: none;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `LabItem-module__font-s-10___RXohR`,
	"fontS12": `LabItem-module__font-s-12___qVMTF`,
	"fontS13": `LabItem-module__font-s-13___abXf2`,
	"fontS14": `LabItem-module__font-s-14___zkuiZ`,
	"fontS15": `LabItem-module__font-s-15___SagDn`,
	"fontS16": `LabItem-module__font-s-16___Q0KK2`,
	"fontS18": `LabItem-module__font-s-18___Ik9aX`,
	"fontS20": `LabItem-module__font-s-20___zqHSO`,
	"fontS22": `LabItem-module__font-s-22___Mbs9A`,
	"fontS28": `LabItem-module__font-s-28___kkZA3`,
	"fontW400": `LabItem-module__font-w-400___kgQB7`,
	"fontW500": `LabItem-module__font-w-500___vnbDy`,
	"fontW600": `LabItem-module__font-w-600___XPfqW`,
	"fontW700": `LabItem-module__font-w-700___iFqDn`,
	"p5": `LabItem-module__p-5___XHmDw`,
	"p12": `LabItem-module__p-12___TS8uC`,
	"p16": `LabItem-module__p-16___RWMla`,
	"p30": `LabItem-module__p-30___vUWgQ`,
	"pB0": `LabItem-module__p-b-0___tGpwd`,
	"pB5": `LabItem-module__p-b-5___hqNGj`,
	"pB10": `LabItem-module__p-b-10___C5mU2`,
	"pB12": `LabItem-module__p-b-12___dMuVX`,
	"pB16": `LabItem-module__p-b-16___OJNk7`,
	"pB18": `LabItem-module__p-b-18___fLo38`,
	"pB20": `LabItem-module__p-b-20___ZBv3_`,
	"pB25": `LabItem-module__p-b-25___p1Hxn`,
	"pB30": `LabItem-module__p-b-30___KHJpJ`,
	"pB50": `LabItem-module__p-b-50___M6cyn`,
	"pT0": `LabItem-module__p-t-0___aPR53`,
	"pT12": `LabItem-module__p-t-12___Xunr6`,
	"pT16": `LabItem-module__p-t-16___VGS_W`,
	"pT18": `LabItem-module__p-t-18___aDTp1`,
	"pT20": `LabItem-module__p-t-20___b71fR`,
	"pT30": `LabItem-module__p-t-30___ugUEI`,
	"pT40": `LabItem-module__p-t-40___RoNyb`,
	"pT50": `LabItem-module__p-t-50___zJUXL`,
	"pL20": `LabItem-module__p-l-20___A25VM`,
	"pL30": `LabItem-module__p-l-30___m0g1n`,
	"pL40": `LabItem-module__p-l-40___QVlSP`,
	"pR16": `LabItem-module__p-r-16___vLMJ9`,
	"pR20": `LabItem-module__p-r-20___UQlaX`,
	"pR30": `LabItem-module__p-r-30___Z9pBY`,
	"pR50": `LabItem-module__p-r-50___kcqEI`,
	"pR60": `LabItem-module__p-r-60___m3914`,
	"mB1": `LabItem-module__m-b-1___Tu1sr`,
	"mB2": `LabItem-module__m-b-2___Iuj7q`,
	"mB6": `LabItem-module__m-b-6___PDLL7`,
	"mB8": `LabItem-module__m-b-8___z8xfV`,
	"mB10": `LabItem-module__m-b-10___G68uC`,
	"mB14": `LabItem-module__m-b-14___YWALU`,
	"mB16": `LabItem-module__m-b-16___NUcYq`,
	"mB20": `LabItem-module__m-b-20___S5t_S`,
	"mB22": `LabItem-module__m-b-22___Hhuta`,
	"mB24": `LabItem-module__m-b-24___ixY2O`,
	"mB30": `LabItem-module__m-b-30___J8vaj`,
	"mB32": `LabItem-module__m-b-32___dowoW`,
	"mB40": `LabItem-module__m-b-40___xnh3v`,
	"mT2": `LabItem-module__m-t-2___dNm4g`,
	"mT3": `LabItem-module__m-t-3____bHye`,
	"mT4": `LabItem-module__m-t-4___MaK2U`,
	"mT5": `LabItem-module__m-t-5___X02eE`,
	"mT8": `LabItem-module__m-t-8___HmUTW`,
	"mT10": `LabItem-module__m-t-10___GApzO`,
	"mT15": `LabItem-module__m-t-15____JYcz`,
	"mT16": `LabItem-module__m-t-16____wU1A`,
	"mT20": `LabItem-module__m-t-20___G_mKs`,
	"mT22": `LabItem-module__m-t-22___obb0N`,
	"mT30": `LabItem-module__m-t-30___nOydx`,
	"mT32": `LabItem-module__m-t-32___fFnam`,
	"mLAuto": `LabItem-module__m-l-auto___EJAoN`,
	"mL4": `LabItem-module__m-l-4___xa6TP`,
	"mL5": `LabItem-module__m-l-5___yHYmD`,
	"mL6": `LabItem-module__m-l-6___kkbGd`,
	"mL8": `LabItem-module__m-l-8___XC5wL`,
	"mL10": `LabItem-module__m-l-10___BxUp9`,
	"mL16": `LabItem-module__m-l-16___dl_Xj`,
	"mL20": `LabItem-module__m-l-20___I7wnu`,
	"mL24": `LabItem-module__m-l-24___mJenI`,
	"mL30": `LabItem-module__m-l-30___EQ60q`,
	"mL35": `LabItem-module__m-l-35___n75eg`,
	"mL40": `LabItem-module__m-l-40___fQOEX`,
	"mR8": `LabItem-module__m-r-8___pqkim`,
	"mR10": `LabItem-module__m-r-10___jWvDg`,
	"mR16": `LabItem-module__m-r-16___UUBm_`,
	"mR20": `LabItem-module__m-r-20___uI5WO`,
	"mR24": `LabItem-module__m-r-24___wp2nr`,
	"mR30": `LabItem-module__m-r-30___lE0pd`,
	"mR40": `LabItem-module__m-r-40___Qsw1o`,
	"borderR3": `LabItem-module__border-r-3___d5cV7`,
	"borderR4": `LabItem-module__border-r-4___CmlmP`,
	"borderR6": `LabItem-module__border-r-6___cWwCB`,
	"borderR10": `LabItem-module__border-r-10___JoKD7`,
	"borderR12": `LabItem-module__border-r-12___fedfG`,
	"borderR16": `LabItem-module__border-r-16___L41y0`,
	"borderR50": `LabItem-module__border-r-50___rb43L`,
	"primaryBorder": `LabItem-module__primary-border___BmQl4`,
	"primaryBorderB": `LabItem-module__primary-border-b___P12jV`,
	"primaryBorderT": `LabItem-module__primary-border-t___aBolF`,
	"primaryBorderL": `LabItem-module__primary-border-l___scXR2`,
	"primaryBorderR": `LabItem-module__primary-border-r___WEO2Y`,
	"secondaryBorder": `LabItem-module__secondary-border___R0L8O`,
	"secondaryBorderB": `LabItem-module__secondary-border-b___Cd1_L`,
	"secondaryBorderT": `LabItem-module__secondary-border-t____t3Hf`,
	"secondaryBorderL": `LabItem-module__secondary-border-l___h2vqp`,
	"secondaryBorderR": `LabItem-module__secondary-border-r___QutMq`,
	"gap0": `LabItem-module__gap-0___XoW2N`,
	"gap2": `LabItem-module__gap-2___VO22Z`,
	"gap4": `LabItem-module__gap-4___u6ig2`,
	"gap5": `LabItem-module__gap-5___T5xrC`,
	"gap6": `LabItem-module__gap-6___UNdqK`,
	"gap8": `LabItem-module__gap-8___rzmqm`,
	"gap10": `LabItem-module__gap-10___q0zvC`,
	"gap12": `LabItem-module__gap-12___YmSNF`,
	"gap14": `LabItem-module__gap-14___IHG5I`,
	"gap16": `LabItem-module__gap-16___IOTXt`,
	"gap18": `LabItem-module__gap-18___BOYWD`,
	"gap20": `LabItem-module__gap-20___AkfW1`,
	"gap24": `LabItem-module__gap-24___YCHN5`,
	"gap26": `LabItem-module__gap-26___ZiN2x`,
	"gap30": `LabItem-module__gap-30___Tskb9`,
	"gap32": `LabItem-module__gap-32___EpOLO`,
	"gap40": `LabItem-module__gap-40___s4dRc`,
	"gap50": `LabItem-module__gap-50___NHR5n`,
	"flex1": `LabItem-module__flex-1___SMWu2`,
	"flexNone": `LabItem-module__flex-none___BQ2iv`,
	"flexColumn": `LabItem-module__flex-column___GnuQx`,
	"flexRow": `LabItem-module__flex-row___BD6LW`,
	"verticallyCentered": `LabItem-module__vertically-centered___GqZ7a`,
	"horizontallyCentered": `LabItem-module__horizontally-centered___oIsmx`,
	"horizontallyEnd": `LabItem-module__horizontally-end___HzwMS`,
	"verticallyStart": `LabItem-module__vertically-start___nVIjE`,
	"spaceBetween": `LabItem-module__space-between___M_CoM`,
	"flexWrap": `LabItem-module__flex-wrap___s8JEE`,
	"height100": `LabItem-module__height-100___eXHme`,
	"width50": `LabItem-module__width-50___ZFSiH`,
	"width100": `LabItem-module__width-100___JiQEg`,
	"cursorPointer": `LabItem-module__cursor-pointer___Yaa7g`,
	"cursorNotAllowed": `LabItem-module__cursor-not-allowed___H_qym`,
	"absoluteCentered": `LabItem-module__absolute-centered___pA1uL`,
	"absolute": `LabItem-module__absolute___EAtXF`,
	"relative": `LabItem-module__relative___Ey486`,
	"fixed": `LabItem-module__fixed___dYMme`,
	"visible": `LabItem-module__visible___fABPI`,
	"invisible": `LabItem-module__invisible___yB_ul`,
	"col90": `LabItem-module__col-90___K7GAq`,
	"colAuto": `LabItem-module__col-auto___uxkAG`,
	"medicalTabs": `LabItem-module__medical-tabs___xjBtI`,
	"medicalTableNew": `LabItem-module__medical-table-new___RxMdm`,
	"noPagination": `LabItem-module__no-pagination___RIBBw`,
	"medicalTableEmpty": `LabItem-module__medical-table-empty___XubMC`,
	"iconBtn": `LabItem-module__icon-btn___Mh73m`,
	"searchIcon": `LabItem-module__search-icon___OxJjF`,
	"disableSelect": `LabItem-module__disable-select___HCdGV`,
	"breakWord": `LabItem-module__break-word___Z3vZs`,
	"popupClearBtn": `LabItem-module__popup-clear-btn___eTMuC`,
	"scrollMB20": `LabItem-module__scroll-m-b-20___x7TEm`,
	"item": `LabItem-module__item____ejlH`,
	"borderRadius": `LabItem-module__borderRadius___tvWW_`,
	"content": `LabItem-module__content___jAg8L`,
	"icon": `LabItem-module__icon___KHmNu`,
	"type": `LabItem-module__type___LmbB2`,
	"value": `LabItem-module__value___eyr1k`,
	"description": `LabItem-module__description___MibVV`,
	"button": `LabItem-module__button___D6reY`,
	"toggleButton": `LabItem-module__toggleButton___GC6Uh`,
	"collapsed": `LabItem-module__collapsed___Afefa`,
	"accordion": `LabItem-module__accordion___v60Vq`
};
module.exports = ___CSS_LOADER_EXPORT___;
